export * from './section-with-image-v2-wrapper'
